export class ConvertResourceSnapshotsRequest {
    'vaultId';
    'retentionDays';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "vaultId",
            "baseName": "vaultId",
            "type": "string",
            "format": ""
        },
        {
            "name": "retentionDays",
            "baseName": "retentionDays",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ConvertResourceSnapshotsRequest.attributeTypeMap;
    }
    constructor() {
    }
}
